import { render, staticRenderFns } from "./AIPromptEditor.vue?vue&type=template&id=56389212&scoped=true"
import script from "./AIPromptEditor.vue?vue&type=script&lang=js"
export * from "./AIPromptEditor.vue?vue&type=script&lang=js"
import style0 from "./AIPromptEditor.vue?vue&type=style&index=0&id=56389212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56389212",
  null
  
)

export default component.exports